import { get } from '@alltrails/core/utils/get';
import { post } from '@alltrails/core/utils/post';
import getPhotoUrl from '@alltrails/core/utils/getPhotoUrl';
import logError from '@alltrails/core/utils/logError';
import { PhotosResponse } from '@alltrails/denali/types';

export const saveCollectionToLists = (listIds: number[], name: string) =>
  post<void>('/api/alltrails/lists/multi-copy', { list_ids: listIds, name });

export const getLocationPhotoUrls = async (type, location, perPage = 5) => {
  try {
    const params = new URLSearchParams();
    params.append('per_page', String(perPage));
    if (type === 'states') {
      params.append('country_id', String(location.country));
    }

    const data = await get<{ photos: PhotosResponse[] }>(`/api/alltrails/locations/${type}/${location.id}/photos?${params.toString()}`);
    if (data?.photos) {
      return data.photos.map(photo => getPhotoUrl({ photo: { id: photo.id, photoHash: photo.photoHash }, size: '500x500' }));
    } else {
      return [];
    }
  } catch (e) {
    logError(new Error(`Error when getting location photo urls: ${e}`));
    return [];
  }
};
